import React, { useEffect } from 'react';
import { useNavigate, Link as RouterLink, useParams } from 'react-router-dom';

// material-ui
import { Box, Button, Card, Grid, IconButton, Typography, useMediaQuery } from '@mui/material';
import AlertTitle from '@mui/material/AlertTitle';

// project imports
import AuthCardWrapper from '../AuthCardWrapper';
import AuthWrapper1 from '../AuthWrapper1';

import Logo from 'ui-component/Logo';
import { useTheme } from '@mui/material/styles';
import AuthFooter from 'ui-component/cards/AuthFooter';
import useMasterSurveyResponseStore from 'zustand_store/useMasterSurveyResponseStore';
import SurveyService from 'services/survey.service';
import AnimateButton from 'ui-component/extended/AnimateButton';
import ChartWrapper from './ChartWrapper';
import ListSkeleton from 'ui-component/custom/ListSkeleton';
import { margin } from '@mui/system';
import { IconBrandFacebook, IconBrandLinkedin, IconBrandTwitter, IconMail } from '@tabler/icons';

// assets

// ==============================|| AUTH3 - CHECK MAIL ||============================== //

const SurveyCompletedResults = () => {
    const navigate = useNavigate();
    const { shortcode } = useParams();

    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const [score, setScore] = React.useState(null);
    const [survey, setSurvey] = React.useState({});
    const [isSurveyDataLoaded, setIsSurveyDataLoaded] = React.useState(false);
    const [response, setResponse] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const surveyShortUrl = window.location.href;
    const twitterText = `Share Survey Result--→ ${surveyShortUrl}%0A%0A`;
    const emailSubject = 'Share Survey Result';

    const surveyShortCode = useMasterSurveyResponseStore((state) => state.survey_short_code);
    const responseContainer = useMasterSurveyResponseStore((state) => state.responseContainer);

    const fetchResponses = async (survey) => {
        const resp = await SurveyService.getGraphResponse(survey.survey_token);
        setResponse(resp.data.data);
    };

    const handleSurveyScoreOnAssessment = async () => {
        const { data } = await SurveyService.getSurveyFromShortCode(shortcode);
        setSurvey(data);
        if (data.survey_type === 'Assessment' && responseContainer.responses.length > 0) {
            const scorePayload = responseContainer.responses.map((res) => ({
                choiceId: Number(res.answer.value),
                questionId: res.qID
            }));
            const { data: response } = await SurveyService.assessAnswerScore({ choices: scorePayload });
            setScore(response.score);
            setIsLoading(false);
            setIsSurveyDataLoaded(true);
        }
        if (data.survey_type === 'Poll') {
            fetchResponses(data);
            setIsLoading(false);
            setIsSurveyDataLoaded(true);
        }
    };

    useEffect(() => {
        handleSurveyScoreOnAssessment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     // if (survey?.meta) {
    //     //     setIsSurveyDataLoaded(true);
    //     // }
    //     setTimeout(() => {
    //         if (survey?.meta?.redirection_url) {
    //             window.location.href = survey?.meta?.redirection_url;
    //         }
    //     }, 3000);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [survey]);

    return (
        <Box sx={{ maxWidth: '720px', margin: '0 auto', minHeight: 'calc(100vh - 68px)' }}>
            <Card sx={{ margin: '50px 0', textAlign: 'center' }}>
                <RouterLink to="#">
                    <Logo />
                </RouterLink>
            </Card>
            <Card>
                <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'} mb={5} textAlign="center">
                    Thank you! There are some insights on this survey:
                </Typography>
                {isSurveyDataLoaded &&
                    response &&
                    response.choices_report_data &&
                    Object.keys(response.choices_report_data).map((element, index) => (
                        <Grid container direction="row" mb={4} index={index}>
                            <Grid item xs={12}>
                                <Grid container direction="column">
                                    <Grid item>
                                        <Typography variant="h4" align="left">
                                            {`${index + 1}.${response?.questions.find((e) => e.id === Number(element)).question_title}`}
                                        </Typography>
                                    </Grid>
                                    <Grid item mt={4}>
                                        <ChartWrapper
                                            choiceData={response?.choices_report_data[element]}
                                            questionData={response?.questions.find((e) => e.id === Number(element))}
                                            toggle={false}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                {isSurveyDataLoaded && response && response.choices_report_data ? (
                    <>
                        <Typography variant="h4">{response?.total_votes ?? 0} Votes</Typography>
                        <Grid spacing={2} mt={2} sx={{ textAlign: 'center' }}>
                            <Grid item md={6}>
                                <Typography variant="h4">Share Results: </Typography>

                                <IconButton
                                    color="primary"
                                    component="a"
                                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(surveyShortUrl)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <IconBrandFacebook />
                                </IconButton>
                                <IconButton
                                    component="a"
                                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(surveyShortUrl)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="primary"
                                >
                                    <IconBrandLinkedin />
                                </IconButton>
                                <IconButton
                                    component="a"
                                    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(twitterText)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="primary"
                                >
                                    <IconBrandTwitter />
                                </IconButton>
                                <IconButton component="a" href={`mailto:?subject=${encodeURIComponent(emailSubject)}`} color="primary">
                                    <IconMail />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <ListSkeleton times={10} />
                )}
            </Card>
        </Box>
    );
};

export default SurveyCompletedResults;
